var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _circle2, _text4, _text5, _rect4, _circle3, _text6, _text7, _rect5, _circle4, _text8, _text9, _path, _rect6, _text0, _path2, _rect7, _circle5, _text1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentImplementationAdoptionOperationalModelMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 650,
    viewBox: "0 0 360 650",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Implementation and adoption model") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 358,
    height: 648,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 39,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 24,
    dy: 0
  }, "IMPLEMENTATION WORKSTREAMS"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 64,
    width: 312,
    height: 72,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 100,
    r: 8,
    fill: "#087CFF",
    fillOpacity: 0.18,
    stroke: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 94,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "PEOPLE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 113,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Roles, training and adoption")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 148,
    width: 312,
    height: 72,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 184,
    r: 8,
    fill: "#30D6A1",
    fillOpacity: 0.18,
    stroke: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 178,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "DATA")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 197,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Migration, quality and ownership")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 232,
    width: 312,
    height: 72,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 268,
    r: 8,
    fill: "#FF2775",
    fillOpacity: 0.18,
    stroke: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 262,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "INTEGRATIONS")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 281,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Systems, interfaces and access")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 316,
    width: 312,
    height: 72,
    rx: 14,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 352,
    r: 8,
    fill: "#F4B63D",
    fillOpacity: 0.18,
    stroke: "#F4B63D"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 346,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 820
  }, "CONTROLS")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 365,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 620
  }, "Permissions, rules and assurance")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 388v34",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 423,
    width: 270,
    height: 86,
    rx: 18,
    fill: "#07152A"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 458,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 15,
    fontWeight: 850,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "ONE IMPLEMENTATION"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 19
  }, "PLAN"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180 509v28",
    stroke: "#4A9BE4",
    strokeWidth: 2,
    strokeDasharray: "4 6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 538,
    width: 312,
    height: 82,
    rx: 16,
    fill: "#10243E",
    stroke: "#2B5A85"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 579,
    r: 7,
    fill: "#30D6A1"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 69,
    y: 568,
    fill: "#FFFFFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 790,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 69,
    dy: 0
  }, "OPERATIONAL ADOPTION"), /*#__PURE__*/React.createElement("tspan", {
    x: 69,
    dy: 20
  }, "Used, measured and improved in real work."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentImplementationAdoptionOperationalModelMobile);
export default __webpack_public_path__ + "static/media/custom-development-implementation-adoption-operational-model-mobile.f1d80c3674673df0df73f02003514df4.svg";
export { ForwardRef as ReactComponent };